


































import Vue from 'vue'
import Component from 'vue-class-component'
import { IJobPosting } from '@app/componentlib/common/types/JobSearchTypes'
import { niceDate } from '@app/componentlib/src/application/helpers/timeHelpers'
import { AppModule } from '@app/componentlib/src/store/modules/app'
import { SavedAdvertsModule } from '@app/componentlib/src/store/modules/JobMatch/savedAdverts'
import HeartEmptyFull from '@app/componentlib/src/views/components/HeartEmptyFull.vue'

let infiniteScroll = require('vue-infinite-scroll')
new Vue({
  directives: {infiniteScroll}
})

@Component<JobResultList>({
  components: {
    HeartEmptyFull
  },
  props: {
    jobPostings: Array,
    infiniteScrollDistance: Number,
    useSavedAdvert: Boolean,
    activeIndex: Number
  }
})

export default class JobResultList extends Vue {
  /**
   * Props variables
   */
  jobPostings: IJobPosting[] | undefined
  infiniteScrollDistance: number | undefined
  useSavedAdvert: boolean | undefined
  activeIndex: Number | undefined

  /**
   * Component state variables
   */


  /**
   * Lifecycle
   */
  mounted() {
    if(this.isMobile && this.activeIndex !== 0 && this.activeIndex !== undefined) {
      let el = document.getElementById(this.activeIndex.toString())?.offsetTop
      window.scrollTo({ top: el })
    }
  }

  /**
   * Getters
   */
  get t (): any {
    return AppModule.translations
  }

  get isMobile (): boolean {
    return AppModule.isMobile
  }

  get disableSearchForMore(): boolean {
    return SavedAdvertsModule.disableSearchForMore
  }

  get testingEnabled(): boolean {
    if (process.env.VUE_APP_TESTING_ENABLED !== undefined)
      return process.env.VUE_APP_TESTING_ENABLED === '1' ? true : false

    return false
  }

  /**
   * Methods
   */
  setSelectedJobPosting(jobPosting: IJobPosting) {
    this.$emit('setSelectedJobPosting', jobPosting)
  }

  setActiveIndex(index: number) {
    this.$emit('setActiveIndex', index)
  }

  formatDate(date: Date) {
    return niceDate(date)
  }

  searchForMore() {
    if(this.disableSearchForMore === false) {
      this.$emit('searchForMore')
    }
  }

  toggleSavedAdvert(posting: IJobPosting, event: any) {
    this.$emit('toggleSavedAdvert', posting)
  }

}
